import React, { useState } from "react";
import StyledLandingPage from "./styles";
import referralImage from "../../assets/ReferralsImage.png";
import MomentumSolar from "./assets/momentum SOLAR ref@2x.png";
import Container from "../../Components/Container";
import { sendEmail } from "../../API/API";

const initialValues = {
  name: "",
  phone: "",
  address: "",

  state: "",
  zip: "",
  marketingAmericaId: "",
};

const formVals = [
  {
    id: 1,
    label: "Name",

    key: "name",
  },
  {
    id: 2,
    label: "Phone",

    key: "phone",
  },
  {
    id: 3,
    label: "Street Address",

    key: "address",
  },

  {
    id: 6,
    label: "State",
    type: "select",
    options: ["NJ", "PA", "NY", "CA", "FL", "TX", "CT"].sort(),
    key: "state",
  },
  {
    id: 7,
    label: "Zip Code",

    key: "zip",
  },
  {
    id: 8,
    label: "Marketing America Associate ID",

    key: "marketingAmericaId",
  },
];

const Referral = () => {
  const [values, setValues] = useState({ ...initialValues });
  const [errors, setErrors] = useState({ ...initialValues });
  const [message, setMessage] = useState("");

  const setValuesAndClearErrors = (e, key) => {
    setValues({
      ...values,
      [key]: e.target.value,
    });

    setErrors({
      ...errors,
      [key]: "",
    });
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setMessage("");
    console.log(values);
    let reducedErrors = Object.keys(values).reduce((prev, curr) => {
      if (values[curr] === "") {
        prev = {
          ...prev,
          [curr]: `Please Enter Value for ${curr}`,
        };
      } else {
        prev = {
          ...prev,
          [curr]: "",
        };
      }
      return prev;
    }, {});
    setErrors(reducedErrors);

    if (Object.values(values).includes("")) {
      setMessage("Please check all Fields before submitting");
      return;
    } else {
      console.log(values);
      try {
        await sendEmail(values);
        setValues(initialValues);
        setMessage("Refferal Submitted Successfully");
      } catch (e) {
        setMessage(
          "There was an issue submitting your referral, copy down the information and call us directly"
        );
      }
    }
  };

  const referralCopy1 = [
    "You can earn thousands when you refer Momentum",
    "Solar to any of your family, friends or neighbors.",
  ];

  return (
    <Container>
      <StyledLandingPage>
        <div
          style={{
            color: "white",
          }}
          className="momentumLogo"
        >
          <img alt="momentum-solar" src={MomentumSolar} />
          {/* <span style={{ fontSize: "32px" }}>momentum</span>
          <span style={{ fontSize: "28px" }}> SOLAR</span> */}
        </div>

        <img className="palm" src={referralImage} alt="referrals" />
        <div className="suburbDiv">
          <div className="textBlurbs">
            <div className="topText">Spread the Sunshine!</div>
            <div className="bottomText">
              <div className="copy-1">
                {referralCopy1.map((c) => (
                  <span key={c}>{c}</span>
                ))}
              </div>
            </div>
          </div>
          <div className="formContainer">
            <p className="referral">Referral</p>

            {formVals.map(
              ({ type, options = [], key, label, placeholder = "", id }) =>
                type === "select" ? (
                  <select
                    key={`${key}`}
                    className={"greyInputs small"}
                    placeholder={label}
                    value={values[key]}
                    onChange={(e) => setValuesAndClearErrors(e, key)}
                    name={key}
                  >
                    <option disabled value="">
                      Select A State
                    </option>
                    {options.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    key={`${key}`}
                    className={
                      key === "state" || key === "zip"
                        ? "greyInputs small"
                        : "greyInputs"
                    }
                    placeholder={label}
                    value={values[key]}
                    onChange={(e) => setValuesAndClearErrors(e, key)}
                    name={key}
                  />
                )
            )}

            {/* {Object.entries(input).map(([key, val]) => {
              console.log(key, val);
              return (
                <input
                  key={`${key}`}
                  className="greyInputs"
                  placeholder={key
                    .split("")
                    .map((y, i) => (i === 0 ? y.toUpperCase() : y))
                    .join("")
                    .split(/(?=[A-Z])/)
                    .join(" ")}
                  value={val}
                  onChange={(e) => handleChange(e)}
                  name={key}
                />
              );
            })} */}
            <button onClick={(e) => submitForm(e)} className="submitButton">
              Submit
            </button>
            {message}
          </div>
        </div>
      </StyledLandingPage>
    </Container>
  );
};

export default Referral;
